import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api, formatApiErrorDetail } from "../../lib/api";
import ReportFilters, { EMPTY_FILTERS } from "../../components/reports/ReportFilters";
import ReportRowsTable from "../../components/reports/ReportRowsTable";

export default function ScanReport() {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async (f = filters) => {
    setLoading(true);
    try {
      const params = {};
      Object.entries(f).forEach(([k, v]) => {
        if (!v) return;
        params[k] = v;
      });
      // Scan Report uses `user_id` param (aliases to member_id on backend)
      if (params.user_id) {
        params.member_id = params.user_id;
        delete params.user_id;
      }
      const { data } = await api.get("/reports/scan-report", { params });
      setRows(data || []);
    } catch (e) {
      toast.error(
        formatApiErrorDetail(e?.response?.data?.detail) || "Failed to load scan report"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(EMPTY_FILTERS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onReset = () => {
    setFilters(EMPTY_FILTERS);
    load(EMPTY_FILTERS);
  };

  return (
    <div data-testid="scan-report-page">
      <header className="bg-white border-b border-black/5 px-8 py-5 flex items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold text-[#0A0A0A] tracking-tight">
            Master Scan Report
          </h1>
          <p className="text-xs text-[#525252] mt-0.5">
            All mobile QR scans. Filter by date range, scanner (member) and location.
          </p>
        </div>
      </header>

      <div className="p-8">
        <ReportFilters
          userLabel="Member"
          userApiPath="/members"
          value={filters}
          onChange={setFilters}
          onApply={() => load(filters)}
          onReset={onReset}
          loading={loading}
        />

        <ReportRowsTable
          rows={rows}
          loading={loading}
          emptyText="No scans found for the selected filters."
        />
      </div>
    </div>
  );
}
